import { render, staticRenderFns } from "./CLogo.vue?vue&type=template&id=3774f8b6&"
import script from "./CLogo.vue?vue&type=script&lang=js&"
export * from "./CLogo.vue?vue&type=script&lang=js&"
import style0 from "./CLogo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports